const Links = {
  BLOG: "/blog",
  APPLICATION: "/application",
  INDEX: "/",
  WHAT_IS_CYBER_INSURANCE: "/what-is-cyber-insurance",
  ToS: "/terms-of-service",
  PRIVACY_POLICY: "/privacy-policy",
  QUOTE: "/quote",
  BIND_REQUEST_SUBMITTED: "/bind-request-submitted",
  QUOTE_APPLICATION_SETUP: "/quote/application-setup",
  QUOTE_COMPARISON: "/quote-comparison",
  BUSINESS: "/business",
  BROKER: "/broker",
  BIND_POLICY: "/bind",
};

export default Links;
